import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  TextField,
} from '@mui/material';
import { useState } from 'react';

import { Button } from '@/components/Button';
import { Sprint } from '@/tracker/types';
import { PresenceDialog } from '@/tracker/ui/PresenceDialog';

const TO_BACKLOG = '';

type Props = {
  sprint: Sprint;
  /** Куда можно перенести: другие открытые спринты доски */
  targets: Sprint[];
  unfinishedCount: number;
  isSaving: boolean;
  onSubmit: (moveUnfinishedTo: string | null) => Promise<boolean>;
  onClose: () => void;
};

/** Завершение спринта: незавершённые задачи — в другой спринт доски или в бэклог */
const CloseSprintDialog: React.FC<Props> = ({
  sprint,
  targets,
  unfinishedCount,
  isSaving,
  onSubmit,
  onClose,
}) => {
  // Как в Яндекс Трекере: по умолчанию — в следующий спринт, если он есть
  const [target, setTarget] = useState(targets[0]?.id ?? TO_BACKLOG);

  const submit = async () => {
    if (await onSubmit(target || null)) onClose();
  };

  return (
    <PresenceDialog onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Завершить «{sprint.name}»</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <DialogContentText>
          {unfinishedCount
            ? `Незавершённых задач: ${unfinishedCount}. Куда их перенести?`
            : 'Все задачи спринта завершены.'}
        </DialogContentText>
        {unfinishedCount > 0 && (
          <TextField
            select
            size="small"
            value={target}
            onChange={(event) => setTarget(event.target.value)}
            slotProps={{
              select: {
                displayEmpty: true,
                SelectDisplayProps: { 'aria-label': 'Куда перенести' },
              },
            }}
          >
            {targets.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
            <MenuItem value={TO_BACKLOG}>В бэклог</MenuItem>
          </TextField>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="text" onClick={onClose}>
          Отмена
        </Button>
        <Button onClick={submit} disabled={isSaving}>
          Завершить
        </Button>
      </DialogActions>
    </PresenceDialog>
  );
};

export { CloseSprintDialog };
